import React, {useCallback, ReactNode} from 'react';
import {ModernTooltip, TooltipProps} from '../Tooltip/ModernTooltip';
import {Icon, PriorityIcon} from '@priority-software/priority-style-react';
import {HelpBook} from '../../../features/HelpBook';
import {sendMonitor} from '../../../utils/monitoring';
import {observer} from 'mobx-react-lite';
import {commonHelpBook} from '../../../stores/Form/HelpBook';
import {showHelpbook} from './commonHelpbook';

type Props = {
    helpTitle: string;
    helpText: string;
    searchString: string;
    tooltipText?: string;
    monitorText?: string;
    tooltipStyle?: Omit<TooltipProps, 'children'>;
    helpContent?: ReactNode;
    zIndex?: number;
};

export const CommonHelpbook = observer(
    ({
        helpTitle = '',
        helpText = '',
        searchString,
        monitorText,
        tooltipText,
        tooltipStyle,
        helpContent,
        zIndex
    }: Props) => {
        const handleHelpClick = async () => {
            await showHelpbook({text: {text: helpText}, searchString, helpContent});
            monitorText && sendMonitor(monitorText);
        };

        const onClose = useCallback(() => {
            commonHelpBook.setShowHelp(false);
            commonHelpBook.initHelpPageQueue();
        }, [commonHelpBook]);

        const {
            isLoadingHelpData,
            helpPageQueue,
            addHelpPage,
            setHelpActiveListPage,
            setHelpPageQuery,
            formHelp,
            showHelp,
            removeHelpPage
        } = commonHelpBook;

        return (
            <>
                <ModernTooltip position={'top'} {...tooltipStyle} tooltip={tooltipText}>
                    <Icon icon={PriorityIcon.help} onClick={handleHelpClick} />
                </ModernTooltip>

                <HelpBook
                    helpPageQueue={helpPageQueue}
                    onClose={onClose}
                    title={helpTitle}
                    isLoadingHelpData={isLoadingHelpData}
                    addHelpPage={addHelpPage}
                    setHelpPageQuery={setHelpPageQuery}
                    setHelpActiveListPage={setHelpActiveListPage}
                    removeHelpPage={removeHelpPage}
                    formHelp={formHelp}
                    showHelp={showHelp}
                    zIndex={zIndex}
                />
            </>
        );
    }
);
